"use client";

import { motion } from "framer-motion";

export default function Template( { children }: { children: React.ReactNode } ) {
    return (
        <motion.div
            className="h-full"
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
        >
            {children}
        </motion.div>
    );
}
